module.exports = __webpack_public_path__ + "img/fashion_82.8e7ac9fa.jpg";